<header>
  <h3 class="title">Filters</h3>

  <app-button
    ariaLabel="Close filters"
    class="icon"
    color="neutral"
    (click)="detachBar()">
    <mat-icon>close</mat-icon>
  </app-button>
</header>

<div class="search">
  <app-search-field [(value)]="query" />
</div>

<div class="content">
  @for (field of viewFields(); track field) {
    <app-filter-row [row]="field" />
  }
</div>
